import { useEffect, useState } from "react";

import { getRandomBlendPuzzle, type Puzzle } from "../puzzle";

/**
 * Resolves the random blend for a URL seed (`/blend/:seed`). Returns
 * `undefined` while the SHA-256 derivation is in-flight, and re-derives
 * whenever the seed changes — so navigating between two random blends
 * (or hitting "new random blend") swaps the puzzle without a remount.
 */
export function useRandomBlendPuzzle(seed: string): Puzzle | undefined {
  const [puzzle, setPuzzle] = useState<Puzzle | undefined>(undefined);

  useEffect(() => {
    let cancelled = false;
    // Drop the prior seed's puzzle immediately so the UI can't briefly
    // show the old blend keyed under the new seed's storage id. Bridging
    // an async external source — same pattern as useDailyState.
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setPuzzle(undefined);
    getRandomBlendPuzzle(seed).then((p) => {
      if (!cancelled) setPuzzle(p);
    }, console.error);
    return () => {
      cancelled = true;
    };
  }, [seed]);

  return puzzle;
}
